import {NavigateFunction} from "react-router-dom";
import {getUserTokenOrRedirect} from "../../shared/services/auth.service";
import {AddClientContactDto, ClientContactDto, UpdateClientContactDto} from "./dtos/client-contact.dto";

export async function getClientContacts(navigate: NavigateFunction, clientId: number): Promise<ClientContactDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/clients/${clientId}/contacts`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(async r => r.ok ? (await r.json()) as ClientContactDto[] : Promise.reject(r));
}

export async function createClientContact(navigate: NavigateFunction, clientId: number, contact: AddClientContactDto): Promise<ClientContactDto> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/clients/${clientId}/contacts`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contact),
    }).then(async r => r.ok ? (await r.json()) as ClientContactDto : Promise.reject(r));
}

export async function updateClientContact(navigate: NavigateFunction, clientId: number, contactId: number, contact: UpdateClientContactDto): Promise<ClientContactDto> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/clients/${clientId}/contacts/${contactId}`,
    {
      method: 'PATCH',
      body: JSON.stringify(contact),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }).then(async r => r.ok ? (await r.json()) as ClientContactDto : Promise.reject(r));
}

export async function deleteClientContact(navigate: NavigateFunction, clientId: number, contactId: number) {
  const token = await getUserTokenOrRedirect(navigate)
  const response = await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/clients/${clientId}/contacts/${contactId}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

  if (!response.ok) {
    throw new Error(`Failed to delete client contact: ${response.statusText}`);
  }
}

/**
 * Swaps the contact's fields with the client's primary fields server-side and
 * returns the refreshed contact list; re-fetch the client afterwards.
 */
export async function setClientContactAsDefault(navigate: NavigateFunction, clientId: number, contactId: number): Promise<ClientContactDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/clients/${clientId}/contacts/${contactId}/set-as-default`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }).then(async r => r.ok ? (await r.json()) as ClientContactDto[] : Promise.reject(r));
}

/** Every client's additional contacts at once, for Add New Appointment's client search (SQ-666). */
export async function getAllClientContacts(navigate: NavigateFunction): Promise<ClientContactDto[]> {
  const token = await getUserTokenOrRedirect(navigate)
  return await fetch(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/clients/contacts`,
    {headers: {Authorization: `Bearer ${token}`}})
    .then(async r => r.ok ? (await r.json()) as ClientContactDto[] : Promise.reject(r));
}
